import { Space } from 'antd'
import CustomAntButton from 'general/components/Button/CustomAntButton'
import ContentContainer from 'general/components/ContentContainer'
import CustomDataTable from 'general/components/CustomDataTable'
import FilterPopover from 'general/components/CustomPopover/FilterPopover'
import CustomSegmented from 'general/components/CustomSegmented'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import Utils, { getYearsFromDates } from 'general/utils/Utils'
import useFilter from 'hooks/useFilter'
import useRouter from 'hooks/useRouter'
import useSearchDebounce from 'hooks/useSearchDebounce'
import { find } from 'lodash'
import { map } from 'lodash'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { getColumnsAnnouncement, getColumnsDocument } from './columns'
import { useMutation, useQuery } from '@tanstack/react-query'
import { queries } from './queries'
import FindDocumentModal from 'general/components/Modal/FindDocumentModal'
import { STATUS_ACCOUNTINGDOCUMENTS } from 'general/constants/AppConstants'
import { unwrapResult } from '@reduxjs/toolkit'
import { thunkFindAccountingDocument } from 'features/AccountingDocument/accountDoucmentsSlice'
import { useDispatch } from 'react-redux'
import { data } from 'jquery'
import ModalConfirm from 'general/components/Modal/ModalConfirm'
import errAnnouceApi from 'api/errAnnouceApi'
import { setAppSpinning } from 'app/appSlice'
import ToastHelper from 'general/helpers/ToastHelper'
import ModalDataTransmissionLog from 'general/components/ModalDataTransmissionLog'
import ModalDataTransmissionLogAD from 'general/components/ModalDataTransmissionLog/modalDataTransmissionLogAD'
import PreferenceKeys from 'general/constants/PreferenceKeys'
import { useSelector } from 'react-redux'
const { Body, Header } = ContentContainer
export const AnnouncementAction = {
  VIEW: 'VIEW',
  CHECK_STATUS: 'CHECK_STATUS',
  ISSUE: 'ISSUE',
  DELETE: 'DELETE',
  EDIT: 'EDIT',
  VIEW_HISTORY: 'VIEW_HISTORY',
}
const Tabs = [
  {
    id: 0,
    text: 'Thông báo chứng từ lập sai',
    path: '/hoa-don-dau-ra/chung-tu-tncn/xu-ly-ct/thong-bao-lap-sai',
  },
  {
    id: 1,
    text: 'Chứng từ đã thông báo lập sai',
    path: '/hoa-don-dau-ra/chung-tu-tncn/xu-ly-ct/thong-bao-chung-tu-da-lap-thong-bao',
  },
  {
    id: 2,
    text: 'Chứng từ chưa tạo thông báo lập sai',
    path: '/hoa-don-dau-ra/chung-tu-tncn/xu-ly-ct/thong-bao-chung-tu-chua-lap-thong-bao',
  },
]

const ListErrorAnnouncement = ({ currentTab }) => {
  const { navigate } = useRouter()
  const { debouncedSearch, search, setSearch } = useSearchDebounce('')
  const [findDocumentModalShow, setFindDocumentModalShow] = useState(false)
  const [dataSource, setDataSource] = useState([])
  const [panningDataSource, setPanningDataSource] = useState({
    page: 1,
    limit: 20,
    totalItems: 0,
    totalPages: 0,
    key: '',
    isLoading: true,
  })
  const { currentAccount } = useSelector((state) => state?.auth)
  const { company } = useSelector((state) => state?.system)
  const [modalState, setModalState] = useState({
    create: false,
    transmissionLog: false,
    delete: false,
  })
  const [activeErrAnnouce, setActiveErrAnnouce] = useState(null)
  const [transmissionModalShow, setTransmissionModalShow] = useState(false)
  const dispatch = useDispatch()
  const [filters, setFilters] = useFilter(
    'errorInvoiceAnnouncement',
    'gFiltersErrAnnouceList',
  )
  const [dateSerial, setDateSerial] = useState([])
  const {
    data: listData,
    isFetching: isFetchingList,
    refetch,
  } = useQuery(
    queries.lists({
      ...filters,
      invoiceType: currentTab,
    }),
  )

  const sign = async (row) => {
    let signingConfig = {
      signingMethod: company?.activeSigningMethod,
    }
    let errorAnnoucementId = row?.errorAnnoucementId
    let { signingMethod } = signingConfig
    if (signingMethod == 'HSM') {
      try {
        await errAnnouceApi.hsmSignErrAnnouceDocument({
          errorAnnoucementId,
        })

        ToastHelper.showSuccess('Ký thông báo sai sót thành công')
        refetch()
      } catch (e) {
        navigate(
          `/hoa-don-dau-ra/chung-tu-tncn/xu-ly-ct/thong-bao-lap-sai/${errorAnnoucementId}`,
        )
      }
    } else {
      let accessToken = localStorage.getItem(PreferenceKeys.accessToken)
      const urlSchema = `${process.env.REACT_APP_BASE_URL_SCHEMA}${accessToken},message300,${errorAnnoucementId},${company?.taxCode}`
      Utils.openToolSignErrAnnouce(
        urlSchema,
        accessToken,
        dispatch,
        setAppSpinning,
        navigate,
      )
    }
  }

  const onAction = useCallback((action, row) => {
    switch (action) {
      case AnnouncementAction.VIEW:
        // return handleView(row)
        handleViewErrorAnnounce(row.errorAnnoucementId)
        return

      case AnnouncementAction.CHECK_STATUS:
        // return handleCheckStatus(row)
        return
      case AnnouncementAction.ISSUE:
        sign(row)
        // return handleIssue(row)
        return
      case AnnouncementAction.DELETE:
        // return handleDelete(row)
        setActiveErrAnnouce({
          ...row,
          errorAnnoucementId: row?.errorAnnoucementId,
        })
        setModalState({ ...modalState, delete: true })
        return
      case AnnouncementAction.EDIT:
        navigate(
          `/hoa-don-dau-ra/chung-tu-tncn/xu-ly-chung-tu/chinh-sua-thong-bao-sai-sot/${row?.errorAnnoucementId}`,
        )
        return
      case AnnouncementAction.VIEW_HISTORY:
        // return handleViewHistory(row)
        setActiveErrAnnouce(row)
        setTransmissionModalShow(true)
        return
      default:
        console.warn('Unknown action', action)
    }
  }, [])

  const columns = useMemo(() => {
    return currentTab == 0
      ? getColumnsAnnouncement({ onAction })
      : getColumnsDocument({ onAction })
  }, [currentTab])

  const switchTab = (value) => {
    navigate(find(Tabs, { text: value })?.path)
    setSearch('')
  }
  const onchangeDate = (name, value, dateRange) => {
    if (name) {
      setDateSerial(getYearsFromDates({ ...filters, [name]: value }))
    } else {
      setDateSerial(
        getYearsFromDates({
          ...filters,
          startDate: dateRange[0],
          endDate: dateRange[1],
        }),
      )
    }
  }
  useEffect(() => {
    setDateSerial(getYearsFromDates(filters))
  }, [])

  useEffect(() => {
    if (currentTab == 0) {
      refetch()
    } else {
      findDataSource({})
    }
  }, [currentTab])

  const findDataSource = async (param) => {
    setPanningDataSource({
      ...panningDataSource,
      isLoading: true,
    })
    try {
      const data = unwrapResult(
        await dispatch(
          thunkFindAccountingDocument(
            param
              ? {
                  ...panningDataSource,
                  ...param,
                  notErrannouce: currentTab == 1 ? true : false,
                  ...(currentTab == 2
                    ? {
                        status: STATUS_ACCOUNTINGDOCUMENTS.AUTHORITY_CODE_GIVEN,
                      }
                    : {}),
                }
              : panningDataSource,
          ),
        ),
      )
      setDataSource(data.items)
      setPanningDataSource({
        ...panningDataSource,
        ...param,
        isLoading: false,
        totalItems: data.totalItems,
        totalPages: data.totalPages,
      })
    } catch (error) {}
  }

  const { mutate: handleDeleteReport } = useMutation({
    mutationKey: ['ErrorTicketAnnouncement', { action: 'delete' }],
    mutationFn: (data) => {
      return errAnnouceApi.delete(data)
    },
    onMutate: () => dispatch(setAppSpinning(true)),
    onSettled: () => dispatch(setAppSpinning(false)),
    onSuccess: (res) => {
      if (res.result === 'success')
        ToastHelper.showSuccess('Xóa thông báo sai sót thành công')
      refetch()
    },
  })

  const handleViewErrorAnnounce = useCallback(
    async (errorAnnoucementId) => {
      let res

      dispatch(setAppSpinning(true))
      try {
        res = await errAnnouceApi.exportByIdDocument(errorAnnoucementId)
        dispatch(setAppSpinning(false))

        let _newFile = new File([res], 'Thông báo sai sót', {
          type: 'application/pdf',
        })
        var _fileURL = URL.createObjectURL(_newFile)
        window.open(_fileURL, '_blank')
      } catch (e) {
        dispatch(setAppSpinning(false))
      }
    },
    [dispatch],
  )

  return (
    <ContentContainer
      wrapperClassName={'list-error-annoucement'}
      tabs={
        <CustomSegmented
          options={map(Tabs, 'text')}
          defaultValue={Tabs[currentTab].text}
          onChange={switchTab}
        />
      }
    >
      <Header
        titleContent={find(Tabs, { id: currentTab }).text}
        toolBar={
          <Space>
            <CustomAntButton
              text="Lập thông báo"
              iconCn="fa-regular fa-plus"
              antProps={{
                type: 'primary',
                onClick: () => {
                  setFindDocumentModalShow(true)
                },
              }}
            />
          </Space>
        }
      >
        <Space align="center">
          <CustomAntInput
            type="search"
            borderRadius="sm"
            inputProps={{
              value: search,
              onChange: (e) => setSearch(e.target.value),
            }}
          />
          <FilterPopover
            // defaultValues={defaultValue}
            onApply={setFilters}
            savedKey="gFiltersErrAnnouceList"
            onchangeDate={onchangeDate}
          />
        </Space>
      </Header>
      <Body>
        {currentTab == 0 ? (
          <CustomDataTable
            columns={columns}
            dataSource={listData?.rows}
            isLoading={isFetchingList}
            pagination={{
              currentPage: filters?.page,
              rowsPerPage: filters?.limit,
              total: listData?.count,
              onChangePage: (newPage) => {
                let iNewPage = parseInt(newPage)
                setFilters({
                  page: iNewPage,
                })
              },
              onChangeRowsPerPage: (newPerPage) => {
                const iNewPerPage = parseInt(newPerPage)
                setFilters({
                  limit: iNewPerPage,
                  page: 1,
                })
              },
            }}
          />
        ) : (
          <CustomDataTable
            columns={columns}
            dataSource={dataSource}
            isLoading={panningDataSource?.isLoading}
            pagination={{
              currentPage: panningDataSource?.page,
              rowsPerPage: panningDataSource?.limit,
              total: panningDataSource?.totalItems,
              onChangePage: (newPage) => {
                let iNewPage = parseInt(newPage)
                setPanningDataSource({ ...panningDataSource })
                findDataSource({ page: iNewPage })
              },
              onChangeRowsPerPage: (newPerPage) => {
                const iNewPerPage = parseInt(newPerPage)
                setPanningDataSource({ ...panningDataSource })
                findDataSource({ page: 1, limit: iNewPerPage })
              },
            }}
          />
        )}
      </Body>

      <FindDocumentModal
        show={findDocumentModalShow}
        onHide={() => setFindDocumentModalShow(false)}
        title="Chọn chứng từ lập sai"
        checkBoxShow={true}
        selectableRows={true}
        showTab={true}
        status={STATUS_ACCOUNTINGDOCUMENTS.AUTHORITY_CODE_GIVEN}
        // onSave={() => {}}
      />

      {/* <ModalDataTransmissionLog
        show={transmissionModalShow}
        onHide={() => setTransmissionModalShow(false)}
        errAnnouce={activeErrAnnouce}
      />
      <ModalUnauthorized show={showNoRight} setShow={setShowNoRight} /> */}
      <ModalConfirm
        show={modalState.delete}
        setShow={(value) => {
          setModalState({ ...modalState, delete: value })
        }}
        header="Xác nhận"
        content="Bạn chắc chắn muốn xoá thông báo sai sót?"
        handleConfirm={() => {
          handleDeleteReport([activeErrAnnouce?.errorAnnoucementId])
        }}
      />
      <ModalDataTransmissionLogAD
        show={transmissionModalShow}
        onHide={() => setTransmissionModalShow(false)}
        errAnnouce={activeErrAnnouce}
      />
    </ContentContainer>
  )
}

export default ListErrorAnnouncement
